var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataArr && _vm.dataArr.length
    ? _c(
        "table",
        { staticClass: "table" },
        [
          _c(
            "tr",
            _vm._l(_vm.dataArr, function(item) {
              return _c(
                "td",
                {
                  class: {
                    ultimate: !(item.children && item.children.length),
                    single: item.children.length == 0
                  },
                  attrs: {
                    colspan: item.children.length,
                    "data-obj": _vm.objToStr(item)
                  }
                },
                [
                  _vm._v("\n      " + _vm._s(item.name) + "\n      "),
                  _c("children", { attrs: { dataArr: item.children } })
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28aa128f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28aa128f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/children.vue
// module id = 2013
// module chunks = 0